import { useParams } from "react-router-dom";

const useCurrentPuzzleId = () => {
  const { id } = useParams();

  return id;
};

export default useCurrentPuzzleId;
